import _ from "lodash";
import * as echarts from 'echarts';

function triming(str) {
  return str ? str.replace(/^\s\s*/, "").replace(/\s\s*$/, "") : undefined;
}

const globProtos = [
  { name: "$jsonPath", fun: _.get },
  { name: "$echarts", fun: echarts },
];

//注册全局方法
export function registerGlobProto(app) {
  globProtos.forEach((g) => {
    app.prototype[g.name] = g.fun;
  });
}
